module.exports = __webpack_public_path__ + "img/c.bb923f41.jpg";